
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class ModalitaPartecipazione extends Vue {
  @Prop() item!: any;
}
